import { BaseMapPageContent } from "../../shared/components/base/page/BaseMapPageContent";
import { IMapRender } from "../../shared/components/definitions/map/IMapRender";
import { SateliteMapRender } from "../../shared/components/modulos/satelite/map/SateliteMapRender";

export class SatelitePage extends BaseMapPageContent {
  getMapRender(): IMapRender {
    return new SateliteMapRender();
  }
}
